import React from 'react';
import { Box, Text, Grid, GridItem } from '@chakra-ui/react';
import commafy from 'commafy';

const formatAmount = (amount) => {
  if (amount == null || amount === '' || isNaN(parseFloat(amount))) {
    return '0.00';
  }
  return parseFloat(amount).toFixed(2);
};

const SummaryCards = ({ summary }) => {
  if (!summary) return null;

  const summaryItems = [
    {
      label: 'Total Transactions',
      value: summary.total_transactions,
      color: 'brand.blue',
    },
    {
      label: 'Successful Transactions',
      value: summary.successful_transactions,
      color: '#2EAE65',
    },
    {
      label: 'Failed Transactions',
      value: summary.failed_transactions,
      color: '#E24D4D',
    },
    {
      label: 'Pending Transactions',
      value: summary.pending_transactions,
      color: '#FFA500',
    },
    {
      label: 'Total Amount',
      value: `₦${commafy(formatAmount(summary.total_amount))}`,
      color: 'brand.blue',
    },
    {
      label: 'Total Debit',
      value: `₦${commafy(formatAmount(summary.total_debit))}`,
      color: '#E24D4D',
    },
    {
      label: 'Airtime Total',
      value: `₦${commafy(formatAmount(summary.airtime_total))}`,
      color: 'brand.blue',
    },
    {
      label: 'Data Total',
      value: `₦${commafy(formatAmount(summary.data_total))}`,
      color: 'brand.blue',
    },
    {
      label: 'Total Funding',
      value: `₦${commafy(formatAmount(summary.total_funding))}`,
      color: '#2EAE65',
    },
    {
      label: 'Funding Transactions',
      value: summary.total_funding_transactions,
      color: '#2EAE65',
    },
  ];

  return (
    <Box bg="white" p="2rem" borderRadius="8px" mb="2rem" boxShadow="md">
      <Text fontSize="20px" fontFamily="bold" color="brand.header" mb="2rem">
        Transaction Summary
      </Text>
      <Grid
        templateColumns={{
          base: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          lg: 'repeat(5, 1fr)',
        }}
        gap="1.5rem"
      >
        {summaryItems.map((item, index) => (
          <GridItem key={index}>
            <Box
              p="1.5rem"
              borderRadius="8px"
              bg="#F9FAFB"
              border="1px solid"
              borderColor="#E5E7EB"
              _hover={{ borderColor: item.color, boxShadow: 'sm' }}
              transition="all 0.2s"
            >
              <Text
                fontSize="13px"
                fontFamily="medium"
                color="#6B7280"
                mb="0.75rem"
              >
                {item.label}
              </Text>
              <Text fontSize="22px" fontFamily="bold" color={item.color}>
                {item.value}
              </Text>
            </Box>
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};

export { SummaryCards };
